// extracted by mini-css-extract-plugin
export default {"landingDiv":"Landing_landingDiv__CfFYj","mobileDiv":"Landing_mobileDiv__zRtsg","desktopDiv":"Landing_desktopDiv__YITDd"};